export default __webpack_public_path__ + "static/media/pic3-nobg.eb6269c9.png";